import $localStorage from "@/utils/localStorage";
import { xxUrlParams } from "@/utils/getUrlParam";

const qyUserInfo = $localStorage.get("qyUserInfo") || {};
export default {
	data() {
		return {
			OpenId: qyUserInfo.OpenId,
			UserId: qyUserInfo.UserId,
			xxUrlParams,
		};
	},
	methods: {
		wxLogin() {
			let url = encodeURIComponent(window.location.href); //callback url
			let link = encodeURIComponent(`${window.location.origin}/qyLogin.html`); //get code url
			// state 参数不被编译，直接返回
			window.location.replace( `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx0f63648d3ce25ce4&redirect_uri=${link}&response_type=code&scope=snsapi_userinfo&agentid=0&state=${url}#wechat_redirect`)
		},
	},
};
